export default "__VITE_ASSET__HpESxla___"